import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Button } from '../button/button';

@Component({
  selector: 'app-dialog',
  imports: [CommonModule, Button],
  templateUrl: './dialog.html',
  styleUrl: './dialog.css',
})
export class Dialog {
  @Input() title = '';
  @Input() isOpen = true;
  @Input() showCancel = false;
  @Input() showConfirm = false;
  @Input() closeOnOverlay = true;

  @Input() confirmText = 'Continuar';
  @Input() cancelText = 'Cerrar';

  @Output() handleConfirm = new EventEmitter<void>();
  @Output() handleCancel = new EventEmitter<void>();

  onConfirm() {
    this.handleConfirm.emit();
  }

  onCancel() {
    document.body.style.overflow = 'auto';
    this.isOpen = false;
    this.handleCancel.emit();
  }

  ngOnInit() {
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy() {
    document.body.style.overflow = 'auto';
  }
}
